import { Divider } from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import React, { useState } from "react";
import { useIntl } from "react-intl";

import { SearchPageProps } from "../../types";
import Debounce from "../Debounce";
import { IFilter, IFilterElement } from "../Filter";
import SingleSelectFieldCustom from "../SingleSelectField/SingleSelectFieldCustom";

export interface SearchInputCustomProps extends SearchPageProps {
  placeholder: string;
}

const useStyles = makeStyles(
  theme => ({
    input: {
      padding: "10.5px 12px"
    },
    root: {
      flex: 1
    },
    select: {
      "& div": {
        "&:focus": {
          background: "none"
        },
        color: theme.palette.primary.main,
        marginLeft: theme.spacing(1)
      },
      "& svg": {
        color: theme.palette.primary.main
      },
      "&:after, &:before, &:hover": {
        border: "none !important"
      }
    },
    singleSelectField: {
      backgroundColor: "transparent",
      outline: "none",
      width: "200px"
    }
  }),
  {
    name: "SearchInputCustom"
  }
);

export interface SearchInputCustom<TFilterKeys extends string = string>
  extends SearchInputCustomProps {
  // searchFilter: ProductFilterInput;
  onDropDownAdd: (filter: Array<IFilterElement<string>>) => void;
  list: IFilter<TFilterKeys>;
  searchBy: (searchBy: string) => void;
  onClearPagination?: (boolean) => void;
}

const SearchInputCustom: React.FC<SearchInputCustom> = props => {
  const {
    initialSearch,
    onSearchChange,
    onClearPagination,
    placeholder,
    searchBy
  } = props;
  const classes = useStyles(props);
  const [search, setSearch] = React.useState(initialSearch);
  React.useEffect(() => setSearch(initialSearch), [initialSearch]);
  const intl = useIntl();

  const dropDownChoices = [
    {
      label: "Search by SKU",
      value: "SKU"
    },
    {
      label: "Search by Name",
      value: "NAME"
    }
  ];

  const [selected, setSelected] = useState(dropDownChoices[0]?.label);

  return (
    <Debounce debounceFn={onSearchChange}>
      {debounceSearchChange => {
        const handleSearchChange = (event: React.ChangeEvent<any>) => {
          const value = event.target.value;
          setSearch(value);
          if (value === "") {
            onClearPagination(true);
          } else {
            debounceSearchChange(value);
          }
        };

        return (
          <>
            <TextField
              className={classes.root}
              inputProps={{
                className: classes.input,
                placeholder
              }}
              value={search}
              onChange={handleSearchChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SingleSelectFieldCustom
                      className={classes.singleSelectField}
                      choices={dropDownChoices}
                      label={intl.formatMessage({
                        defaultMessage: "Search By Name/SKU"
                      })}
                      placeholder="Search By Name/SKU"
                      onChange={event => {
                        searchBy(event.target.value);
                        setSelected(event.target.value);
                      }}
                      value={selected}
                    />
                    <Divider orientation="vertical" />
                  </InputAdornment>
                )
              }}
            />
          </>
        );
      }}
    </Debounce>
  );
};

SearchInputCustom.displayName = "SearchInputCustom";
export default SearchInputCustom;
